import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { NewTask, Course as Course_1, UpdateCourse, S3UploadFile, NewTask_$reflection, Task_$reflection, Course_$reflection } from "../Shared/SharedModels.jsx";
import { union_type, string_type, class_type, bool_type, record_type, option_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { bind, toArray as toArray_1, defaultArg, map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B, tap } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { successToast, errorToast } from "../Toasts.jsx";
import { startAsPromise } from "../fable_modules/fable-library-js.4.24.0/Async.js";
import { Task, toastServerError, Course } from "../ApiClient.jsx";
import { createElement } from "react";
import React from "react";
import { useCtx } from "../Context.jsx";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Option, Dropdown, Checkbox, Caption2, Caption1, CardHeader, Textarea, Input, Field, tokens, Image, Text as Text$, Spinner, Button, Subtitle1, Card } from "@fluentui/react-components";
import { comparePrimitives, equals, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { iterate, toArray, tryHead, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { AddRegular, ClipboardTaskAddRegular, DismissRegular, CheckmarkCircleRegular, CheckmarkLockRegular, ImageAddRegular, SaveRegular } from "@fluentui/react-icons";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { Browser_Types_File__File_ReadAsByteArray } from "../fable_modules/Fable.Remoting.Client.7.35.0/Extensions.fs.js";
import { sortBy, tryFind, append as append_1, map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Checkbox_toBool } from "../fable_modules/FS.FluentUI.2.5.2/Domain.fs.js";
import { useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { CreateCourseDialog } from "./CreateCourse.jsx";

class Model extends Record {
    constructor(AllCourses, SelectedCourse, AllTasks, CourseForm) {
        super();
        this.AllCourses = AllCourses;
        this.SelectedCourse = SelectedCourse;
        this.AllTasks = AllTasks;
        this.CourseForm = CourseForm;
    }
}

function Model_$reflection() {
    return record_type("EditCourse.Model", [], Model, () => [["AllCourses", array_type(Course_$reflection())], ["SelectedCourse", option_type(Course_$reflection())], ["AllTasks", array_type(Task_$reflection())], ["CourseForm", option_type(CourseFormModel_$reflection())]]);
}

class CourseFormModel extends Record {
    constructor(Course, IsSending, AddTask, File, Img) {
        super();
        this.Course = Course;
        this.IsSending = IsSending;
        this.AddTask = AddTask;
        this.File = File;
        this.Img = Img;
    }
}

function CourseFormModel_$reflection() {
    return record_type("EditCourse.CourseFormModel", [], CourseFormModel, () => [["Course", Course_$reflection()], ["IsSending", bool_type], ["AddTask", option_type(NewTask_$reflection())], ["File", option_type(class_type("Browser.Types.File"))], ["Img", option_type(string_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateAllCourses", "UpdatedSelectedCourse", "UpdateAllTasks", "UpdateForm", "UpdateIsSending", "UpdateImage", "UpdateFile", "UpdateAddTask"];
    }
}

function Msg_$reflection() {
    return union_type("EditCourse.Msg", [], Msg, () => [[["Item", array_type(Course_$reflection())]], [["Item", option_type(Course_$reflection())]], [["Item", array_type(Task_$reflection())]], [["Item", Course_$reflection()]], [["Item", bool_type]], [["Item", option_type(string_type)]], [["Item", option_type(class_type("Browser.Types.File"))]], [["Item", option_type(NewTask_$reflection())]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1: {
            const course = msg.fields[0];
            return new Model(model.AllCourses, course, model.AllTasks, map((c) => (new CourseFormModel(c, false, undefined, undefined, undefined)), course));
        }
        case 2:
            return new Model(model.AllCourses, model.SelectedCourse, msg.fields[0], model.CourseForm);
        case 3: {
            const matchValue = model.CourseForm;
            if (matchValue != null) {
                const form = matchValue;
                return new Model(model.AllCourses, model.SelectedCourse, model.AllTasks, new CourseFormModel(msg.fields[0], form.IsSending, form.AddTask, form.File, form.Img));
            }
            else {
                return model;
            }
        }
        case 4: {
            const matchValue_1 = model.CourseForm;
            if (matchValue_1 != null) {
                const form_1 = matchValue_1;
                return new Model(model.AllCourses, model.SelectedCourse, model.AllTasks, new CourseFormModel(form_1.Course, msg.fields[0], form_1.AddTask, form_1.File, form_1.Img));
            }
            else {
                return model;
            }
        }
        case 5: {
            const matchValue_2 = model.CourseForm;
            if (matchValue_2 != null) {
                const form_2 = matchValue_2;
                return new Model(model.AllCourses, model.SelectedCourse, model.AllTasks, new CourseFormModel(form_2.Course, form_2.IsSending, form_2.AddTask, form_2.File, msg.fields[0]));
            }
            else {
                return model;
            }
        }
        case 6: {
            const matchValue_3 = model.CourseForm;
            if (matchValue_3 != null) {
                const form_3 = matchValue_3;
                return new Model(model.AllCourses, model.SelectedCourse, model.AllTasks, new CourseFormModel(form_3.Course, form_3.IsSending, form_3.AddTask, msg.fields[0], form_3.Img));
            }
            else {
                return model;
            }
        }
        case 7: {
            const matchValue_4 = model.CourseForm;
            if (matchValue_4 != null) {
                const form_4 = matchValue_4;
                return new Model(model.AllCourses, model.SelectedCourse, model.AllTasks, new CourseFormModel(form_4.Course, form_4.IsSending, msg.fields[0], form_4.File, form_4.Img));
            }
            else {
                return model;
            }
        }
        default:
            return new Model(msg.fields[0], model.SelectedCourse, model.AllTasks, model.CourseForm);
    }
}

function init() {
    return new Model([], undefined, [], undefined);
}

function addCourseTask(courseId, taskId, callback, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            if (res.fields[0].tag === 1) {
                errorToast(setCtx, "addCourseTaskConflict", "Kunne ikke legge til oppgave", "Oppgave eksisterer allerede på kursmal", undefined);
            }
            else {
                errorToast(setCtx, "addCourseTaskNotFound", "Kunne ikke legge til oppgave", "Fant ikke kursmal eller oppgave", undefined);
            }
        }
        else {
            const c = res.fields[0];
            callback(c);
            successToast(setCtx, `addCourseTask${c.Id}Success`, "Oppgave lagt til", `Oppgave ${c.Name} ble lagt til i kursmalen`);
        }
    }, startAsPromise(Course.AddCourseTask(courseId, taskId)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function addNewCourseTask(courseId, newCourse, callback, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            if (res.fields[0].tag === 0) {
                errorToast(setCtx, "addNewCourseTaskNotFound", "Kunne ikke legge til oppgave", "Fant ikke kursmal", undefined);
            }
            else {
                errorToast(setCtx, "addNewCourseTaskConflict", "Kunne ikke legge til oppgave", "Det finnes allerede oppgaver med dette navnet", undefined);
            }
        }
        else {
            const c = res.fields[0];
            callback(c);
            successToast(setCtx, `addNewCourseTask${c.Id}Success`, "Oppgave lagt til", `Oppgave ${c.Name} ble lagt til i kursmalen`);
        }
    }, startAsPromise(Course.AddNewCourseTask(courseId, newCourse)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function deleteCourseTask(courseId, taskId, callback, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            errorToast(setCtx, "deleteCourseTaskNotFound", "Kunne ikke fjerne oppgave", "Fant ikke kursmal eller oppgave som prøver å fjernes", undefined);
        }
        else {
            const c = res.fields[0];
            callback(c);
            successToast(setCtx, `deleteCourseTask${c.Id}Success`, "Oppgave fjernet", `Oppgave ${c.Name} ble fjernet fra kursmalen`);
        }
    }, startAsPromise(Course.DeleteCourseTask(courseId, taskId)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function getAllCourses(dispatch, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 0) {
            dispatch(new Msg(0, [res.fields[0]]));
        }
        else {
            errorToast(setCtx, "getTracksError", "Kunne ikke hente kursløp", "Noe gikk galt", undefined);
        }
    }, startAsPromise(Course.GetAllCourses()));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function updateCourse(courseUpdate, callback, setIsSendingFalse, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 0: {
                    errorToast(setCtx, "updateCourseImageNotFound", "Kunne ikke oppdatere kursmal", "Fant ikke kursmal", undefined);
                    break;
                }
                case 2: {
                    errorToast(setCtx, "updateCourseImageUploadFailed", "Kunne ikke oppdatere kursmal", "Bildeopplasting feilet, prøv igjen uten bilde", undefined);
                    break;
                }
                case 1: {
                    errorToast(setCtx, "updateCourseValidationFailed", "Kunne ikke oppdatere kursmal", "Felter kan ikke være tomme", undefined);
                    break;
                }
                default: {
                    errorToast(setCtx, "updateCourseConflict", "Kunne ikke oppdatere kursmal", "Det finnes kursmaler med samme navn", undefined);
                }
            }
        }
        else {
            callback(res.fields[0]);
            successToast(setCtx, `updateCourse${courseUpdate.Course.Id}Success`, "Kursmal oppdatert", `Kursmal ${courseUpdate.Course.Name} oppdatert`);
        }
    }, startAsPromise(Course.UpdateCourse(courseUpdate)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function getTasks(dispatch, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 0) {
            dispatch(new Msg(2, [res.fields[0]]));
        }
        else {
            errorToast(setCtx, "getTasksError", "Kunne ikke hente oppgaver", "Noe gikk galt", undefined);
        }
    }, startAsPromise(Task.GetAllTasks()));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function SelectedCourseView(selectedCourseViewInputProps) {
    let elems_17;
    const dispatch = selectedCourseViewInputProps.dispatch;
    const model = selectedCourseViewInputProps.model;
    const course = selectedCourseViewInputProps.course;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState(false);
    const setNameInputEmptied = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setSummaryInputEmptied = patternInput_2[1];
    const dependencies = [course.Id];
    reactApi.useEffect(() => {
        setNameInputEmptied(false);
        setSummaryInputEmptied(false);
        dispatch(new Msg(3, [course]));
        dispatch(new Msg(6, [undefined]));
        dispatch(new Msg(5, [undefined]));
    }, dependencies);
    const matchValue = model.SelectedCourse;
    const matchValue_1 = model.CourseForm;
    let matchResult, course_1, form;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            matchResult = 0;
            course_1 = matchValue;
            form = matchValue_1;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const el_93 = Card;
            return createElement(el_93, createObj(ofArray([["style", {
                scrollbarWidth: "none",
                overflowY: "scroll",
                flexDirection: "column",
                display: "flex",
                flexGrow: 1,
            }], (elems_17 = toList(delay(() => {
                let elems_1;
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    justifyContent: "space-between",
                }], (elems_1 = toList(delay(() => {
                    let el;
                    return append(singleton((el = Subtitle1, createElement(el, {
                        children: course_1.Name,
                    }))), delay(() => {
                        let el_8, el_2, elems;
                        return (!equals(form.Course, course_1) ? true : (form.File != null)) ? singleton((el_8 = Button, createElement(el_8, createObj(ofArray([["size", "small"], ["icon", (el_2 = SaveRegular, createElement(el_2, {}))], ["appearance", "primary"], ["disabled", ((isNullOrWhiteSpace(form.Course.Name) ? true : isNullOrWhiteSpace(form.Course.Summary)) ? true : form.IsSending) ? true : (form.AddTask != null)], ["onClick", (_arg_1) => {
                            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                                let file;
                                return ((file = form.File, PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                                    if (file != null) {
                                        const f = file;
                                        return startAsPromise(Browser_Types_File__File_ReadAsByteArray(f)).then((_arg_2) => {
                                            let res;
                                            const MimeType = f.type;
                                            res = (new S3UploadFile(f.name, MimeType, _arg_2));
                                            return Promise.resolve(res);
                                        });
                                    }
                                    else {
                                        return Promise.resolve(undefined);
                                    }
                                })))).then((_arg_3) => {
                                    const updateCoursePayload = new UpdateCourse(form.Course, _arg_3);
                                    dispatch(new Msg(4, [true]));
                                    updateCourse(updateCoursePayload, (updatedCourse) => {
                                        dispatch(new Msg(1, [updatedCourse]));
                                        dispatch(new Msg(3, [updatedCourse]));
                                        dispatch(new Msg(6, [undefined]));
                                        dispatch(new Msg(5, [undefined]));
                                        dispatch(new Msg(0, [map_1((c) => {
                                            if (c.Id === updatedCourse.Id) {
                                                return updatedCourse;
                                            }
                                            else {
                                                return c;
                                            }
                                        }, model.AllCourses)]));
                                    }, dispatch(new Msg(4, [false])), setCtx);
                                    return Promise.resolve();
                                });
                            }));
                            void pr;
                        }], (elems = toList(delay(() => {
                            let el_4, el_6;
                            return form.IsSending ? singleton((el_4 = Spinner, createElement(el_4, {
                                size: "extra-small",
                            }))) : singleton((el_6 = Text$, createElement(el_6, {
                                children: "Lagre",
                            })));
                        })), ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))) : empty();
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append(singleton(createElement("input", {
                    id: "image-select-input-edit-course",
                    type: "file",
                    accept: "image/png, image/jpeg",
                    onChange: (ev) => {
                        const files = ev.target.files;
                        if (!(files == null) && (files.length > 0)) {
                            const f_1 = files.item(0);
                            const reader = new FileReader();
                            reader.onload = ((_arg_4) => {
                                const matchValue_3 = reader.result;
                                if (typeof matchValue_3 === "string") {
                                    const base64data = matchValue_3;
                                    dispatch(new Msg(6, [f_1]));
                                    dispatch(new Msg(5, [base64data]));
                                }
                            });
                            reader.readAsDataURL(f_1);
                        }
                    },
                    style: {
                        display: "none",
                    },
                })), delay(() => {
                    let elems_3;
                    return append(singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                    }], (elems_3 = toList(delay(() => {
                        let el_10, el_20, elems_2, el_18, el_14;
                        const matchValue_5 = form.Img;
                        let matchResult_1, i;
                        if (form.File != null) {
                            if (matchValue_5 != null) {
                                matchResult_1 = 0;
                                i = matchValue_5;
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                        switch (matchResult_1) {
                            case 0:
                                return append(singleton((el_10 = Image, createElement(el_10, {
                                    style: {
                                        width: 95 + "%",
                                        maxWidth: 400,
                                        maxHeight: 250,
                                        minHeight: 150,
                                    },
                                    fit: "contain",
                                    src: i,
                                }))), delay(() => {
                                    let el_12;
                                    return singleton((el_12 = Button, createElement(el_12, {
                                        children: "Slett",
                                        size: "small",
                                        onClick: (_arg_5) => {
                                            dispatch(new Msg(6, [undefined]));
                                            dispatch(new Msg(5, [undefined]));
                                        },
                                        appearance: "transparent",
                                    })));
                                }));
                            default: {
                                const matchValue_7 = form.Course.ImageUrl;
                                if (matchValue_7 == null) {
                                    return singleton((el_20 = Button, createElement(el_20, createObj(ofArray([["onClick", (_arg_7) => {
                                        document.getElementById("image-select-input-edit-course").click();
                                    }], ["style", {
                                        width: 95 + "%",
                                        maxWidth: 400,
                                        maxHeight: 250,
                                        minHeight: 150,
                                        borderStyle: "dashed",
                                        borderColor: tokens.colorBrandBackgroundStatic,
                                        borderWidth: 1,
                                    }], (elems_2 = [(el_18 = ImageAddRegular, createElement(el_18, {
                                        fontSize: 48,
                                        primaryFill: tokens.colorBrandForeground2,
                                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))));
                                }
                                else {
                                    const url = matchValue_7;
                                    return append(singleton((el_14 = Image, createElement(el_14, {
                                        style: {
                                            width: 95 + "%",
                                            maxWidth: 400,
                                            maxHeight: 250,
                                            minHeight: 150,
                                        },
                                        fit: "contain",
                                        src: url,
                                    }))), delay(() => {
                                        let el_16;
                                        return singleton((el_16 = Button, createElement(el_16, {
                                            children: "Slett",
                                            size: "small",
                                            onClick: (_arg_6) => {
                                                let bind$0040;
                                                dispatch(new Msg(3, [(bind$0040 = form.Course, new Course_1(bind$0040.Id, bind$0040.Name, bind$0040.Summary, bind$0040.Description, undefined, bind$0040.Inserted, bind$0040.Tasks))]));
                                            },
                                            appearance: "transparent",
                                        })));
                                    }));
                                }
                            }
                        }
                    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                        let el_25;
                        return append(singleton((el_25 = Field, createElement(el_25, createObj(toList(delay(() => append(singleton(["required", true]), delay(() => append(singleton(["label", "Navn"]), delay(() => append(patternInput_1[0] ? append(singleton(["validationMessage", "Navn kan ikke være tom"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
                            let matchValue_8, el_22;
                            return singleton(["children", (matchValue_8 = tryHead([(el_22 = Input, createElement(el_22, {
                                appearance: "filled-darker",
                                type: "text",
                                value: form.Course.Name,
                                onChange: (_arg_8, value_1_12) => {
                                    let bind$0040_1;
                                    const v = value_1_12;
                                    dispatch(new Msg(3, [(bind$0040_1 = form.Course, new Course_1(bind$0040_1.Id, v.value, bind$0040_1.Summary, bind$0040_1.Description, bind$0040_1.ImageUrl, bind$0040_1.Inserted, bind$0040_1.Tasks))]));
                                    setNameInputEmptied(isNullOrWhiteSpace(v.value));
                                },
                            }))]), (matchValue_8 == null) ? defaultOf() : matchValue_8)]);
                        })))))))))))), delay(() => {
                            let el_30;
                            return append(singleton((el_30 = Field, createElement(el_30, createObj(toList(delay(() => append(singleton(["required", true]), delay(() => append(singleton(["label", "Oppsummering"]), delay(() => append(patternInput_2[0] ? append(singleton(["validationMessage", "Oppsummering kan ikke være tom"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
                                let matchValue_9, el_27;
                                return singleton(["children", (matchValue_9 = tryHead([(el_27 = Textarea, createElement(el_27, {
                                    style: {
                                        minHeight: 80,
                                    },
                                    appearance: "filled-darker",
                                    value: form.Course.Summary,
                                    onChange: (_arg_9, value_1_17) => {
                                        let bind$0040_2;
                                        const v_1 = value_1_17;
                                        dispatch(new Msg(3, [(bind$0040_2 = form.Course, new Course_1(bind$0040_2.Id, bind$0040_2.Name, v_1.value, bind$0040_2.Description, bind$0040_2.ImageUrl, bind$0040_2.Inserted, bind$0040_2.Tasks))]));
                                        setSummaryInputEmptied(isNullOrWhiteSpace(v_1.value));
                                    },
                                }))]), (matchValue_9 == null) ? defaultOf() : matchValue_9)]);
                            })))))))))))), delay(() => {
                                let el_35, matchValue_10, el_32;
                                return append(singleton((el_35 = Field, createElement(el_35, {
                                    label: "Beskrivelse",
                                    children: (matchValue_10 = tryHead([(el_32 = Textarea, createElement(el_32, {
                                        style: {
                                            height: 300,
                                        },
                                        appearance: "filled-darker",
                                        value: defaultArg(form.Course.Description, ""),
                                        onChange: (_arg_10, value_1_20) => {
                                            let bind$0040_3;
                                            dispatch(new Msg(3, [(bind$0040_3 = form.Course, new Course_1(bind$0040_3.Id, bind$0040_3.Name, bind$0040_3.Summary, value_1_20.value, bind$0040_3.ImageUrl, bind$0040_3.Inserted, bind$0040_3.Tasks))]));
                                        },
                                    }))]), (matchValue_10 == null) ? defaultOf() : matchValue_10),
                                }))), delay(() => append(map_1((task) => {
                                    let elems_7, el_49, el_37, el_39, el_41, el_43, el_47, el_45;
                                    const el_51 = Card;
                                    return createElement(el_51, createObj(ofArray([["style", {
                                        minHeight: 50,
                                    }], ["size", "small"], ["appearance", "filled-alternative"], (elems_7 = [(el_49 = CardHeader, createElement(el_49, {
                                        header: (el_37 = Caption1, createElement(el_37, {
                                            children: task.Name,
                                        })),
                                        description: (el_39 = Caption2, createElement(el_39, {
                                            children: task.Description,
                                        })),
                                        image: task.VerificationRequired ? ((el_41 = CheckmarkLockRegular, createElement(el_41, {
                                            fontSize: 20,
                                            primaryFill: tokens.colorStatusSuccessForeground1,
                                        }))) : ((el_43 = CheckmarkCircleRegular, createElement(el_43, {
                                            fontSize: 20,
                                            primaryFill: tokens.colorStatusSuccessForeground1,
                                        }))),
                                        action: (el_47 = Button, createElement(el_47, {
                                            onClick: (_arg_11) => {
                                                deleteCourseTask(course_1.Id, task.Id, (removeTask) => {
                                                    const updatedCourse_1 = new Course_1(course_1.Id, course_1.Name, course_1.Summary, course_1.Description, course_1.ImageUrl, course_1.Inserted, course_1.Tasks.filter((t) => (t.Id !== removeTask.Id)));
                                                    dispatch(new Msg(0, [map_1((c_1) => {
                                                        if (c_1.Id === updatedCourse_1.Id) {
                                                            return updatedCourse_1;
                                                        }
                                                        else {
                                                            return c_1;
                                                        }
                                                    }, model.AllCourses)]));
                                                    dispatch(new Msg(3, [updatedCourse_1]));
                                                    dispatch(new Msg(1, [updatedCourse_1]));
                                                }, setCtx);
                                            },
                                            disabled: form.Course.Tasks.length <= 1,
                                            appearance: "transparent",
                                            style: {
                                                padding: 0,
                                                borderWidth: 0,
                                            },
                                            icon: (el_45 = DismissRegular, createElement(el_45, {
                                                style: {
                                                    padding: 0,
                                                },
                                                fontSize: 16,
                                            })),
                                        })),
                                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])));
                                }, form.Course.Tasks), delay(() => {
                                    let elems_16, el_91, elems_15, el_89, elems_13, elems_11, el_66, el_68, el_75, matchValue_13, el_72, el_70, el_77, el_79, elems_14, el_83, el_81, el_87, el_85, children, el_55, el_53;
                                    const matchValue_11 = form.AddTask;
                                    if (matchValue_11 != null) {
                                        const task_2 = matchValue_11;
                                        return singleton(createElement("div", createObj(ofArray([["style", {
                                            display: "flex",
                                            gap: 5 + "px ",
                                        }], (elems_16 = [(el_91 = Card, createElement(el_91, createObj(ofArray([["style", {
                                            flexGrow: 1,
                                        }], ["size", "small"], ["appearance", "filled-alternative"], (elems_15 = [(el_89 = CardHeader, createElement(el_89, {
                                            header: createElement("div", createObj(ofArray([["style", {
                                                display: "flex",
                                                flexDirection: "column",
                                                flexGrow: 1,
                                            }], (elems_13 = [createElement("div", createObj(ofArray([["style", {
                                                display: "flex",
                                                flexGrow: 1,
                                                gap: 5 + "px ",
                                            }], (elems_11 = [(el_66 = Input, createElement(el_66, {
                                                placeholder: "Navn",
                                                onChange: (_arg_15, value_1_38) => {
                                                    dispatch(new Msg(7, [new NewTask(value_1_38.value, task_2.Description, task_2.VerificationRequired)]));
                                                },
                                                size: "medium",
                                                appearance: "filled-darker",
                                            })), (el_68 = Input, createElement(el_68, {
                                                style: {
                                                    display: "flex",
                                                    flexGrow: 1,
                                                },
                                                size: "medium",
                                                appearance: "filled-darker",
                                                placeholder: "Beskrivelse",
                                                onChange: (_arg_16, value_1_40) => {
                                                    dispatch(new Msg(7, [new NewTask(task_2.Name, value_1_40.value, task_2.VerificationRequired)]));
                                                },
                                            }))], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))), (el_75 = Field, createElement(el_75, {
                                                children: (matchValue_13 = tryHead([(el_72 = Checkbox, createElement(el_72, {
                                                    labelPosition: "after",
                                                    label: (el_70 = Caption2, createElement(el_70, {
                                                        children: "Godkjennes av kursholder",
                                                    })),
                                                    checked: task_2.VerificationRequired,
                                                    onChange: (_arg_17, c_3) => {
                                                        dispatch(new Msg(7, [new NewTask(task_2.Name, task_2.Description, Checkbox_toBool(c_3))]));
                                                    },
                                                }))]), (matchValue_13 == null) ? defaultOf() : matchValue_13),
                                            }))], ["children", reactApi.Children.toArray(Array.from(elems_13))])]))),
                                            image: task_2.VerificationRequired ? ((el_77 = CheckmarkLockRegular, createElement(el_77, {
                                                fontSize: 28,
                                            }))) : ((el_79 = CheckmarkCircleRegular, createElement(el_79, {
                                                fontSize: 28,
                                            }))),
                                            action: createElement("div", createObj(singleton_1((elems_14 = [(el_83 = Button, createElement(el_83, {
                                                onClick: (_arg_18) => {
                                                    dispatch(new Msg(7, [undefined]));
                                                },
                                                appearance: "transparent",
                                                style: {
                                                    padding: 0,
                                                    borderWidth: 0,
                                                },
                                                icon: (el_81 = DismissRegular, createElement(el_81, {
                                                    style: {
                                                        padding: 0,
                                                    },
                                                    fontSize: 16,
                                                })),
                                            })), (el_87 = Button, createElement(el_87, {
                                                disabled: (isNullOrWhiteSpace(task_2.Name) ? true : isNullOrWhiteSpace(task_2.Description)) ? true : form.Course.Tasks.some((t_2) => (t_2.Name.toLocaleLowerCase() === task_2.Name.toLocaleLowerCase())),
                                                onClick: (_arg_19) => {
                                                    addNewCourseTask(course_1.Id, task_2, (newTask_1) => {
                                                        let updatedCourse_3;
                                                        const bind$0040_4 = form.Course;
                                                        updatedCourse_3 = (new Course_1(bind$0040_4.Id, bind$0040_4.Name, bind$0040_4.Summary, bind$0040_4.Description, bind$0040_4.ImageUrl, bind$0040_4.Inserted, append_1([newTask_1], form.Course.Tasks)));
                                                        dispatch(new Msg(3, [updatedCourse_3]));
                                                        dispatch(new Msg(7, [undefined]));
                                                        dispatch(new Msg(0, [map_1((c_4) => {
                                                            if (c_4.Id === updatedCourse_3.Id) {
                                                                return updatedCourse_3;
                                                            }
                                                            else {
                                                                return c_4;
                                                            }
                                                        }, model.AllCourses)]));
                                                        dispatch(new Msg(1, [updatedCourse_3]));
                                                    }, setCtx);
                                                },
                                                appearance: "transparent",
                                                icon: (el_85 = ClipboardTaskAddRegular, createElement(el_85, {})),
                                            }))], ["children", reactApi.Children.toArray(Array.from(elems_14))])))),
                                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_15))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_16))])]))));
                                    }
                                    else {
                                        return append(singleton((children = singleton_1((el_55 = Button, createElement(el_55, {
                                            size: "small",
                                            appearance: "transparent",
                                            children: "Legg til oppgave",
                                            icon: (el_53 = AddRegular, createElement(el_53, {})),
                                            onClick: (_arg_12) => {
                                                dispatch(new Msg(7, [new NewTask("", "", false)]));
                                            },
                                        }))), createElement("div", {
                                            children: reactApi.Children.toArray(Array.from(children)),
                                        }))), delay(() => {
                                            let el_64, matchValue_12, el_61, elems_9;
                                            return singleton((el_64 = Field, createElement(el_64, {
                                                label: "Legg til eksisterende oppgaver",
                                                children: (matchValue_12 = tryHead([(el_61 = Dropdown, createElement(el_61, createObj(ofArray([["appearance", "filled-darker"], ["style", {
                                                    minWidth: 250,
                                                    width: 250,
                                                }], ["selectedOptions", toArray(map_1((_arg_13) => _arg_13.Name, course_1.Tasks))], ["onOptionSelect", (_arg_14, value_1_33) => {
                                                    iterate((optText) => {
                                                        iterate((foundTask) => {
                                                            addCourseTask(course_1.Id, foundTask.Id, (newTask) => {
                                                                const updatedCourse_2 = new Course_1(course_1.Id, course_1.Name, course_1.Summary, course_1.Description, course_1.ImageUrl, course_1.Inserted, append_1([newTask], course_1.Tasks));
                                                                dispatch(new Msg(0, [map_1((c_2) => {
                                                                    if (c_2.Id === updatedCourse_2.Id) {
                                                                        return updatedCourse_2;
                                                                    }
                                                                    else {
                                                                        return c_2;
                                                                    }
                                                                }, model.AllCourses)]));
                                                                dispatch(new Msg(3, [updatedCourse_2]));
                                                                dispatch(new Msg(1, [updatedCourse_2]));
                                                            }, setCtx);
                                                        }, toArray_1(tryFind((task_1) => (task_1.Name === optText), model.AllTasks)));
                                                    }, toArray_1(value_1_33.optionText));
                                                }], (elems_9 = toList(delay(() => map_1((t_1) => {
                                                    let elems_8, el_57;
                                                    const el_59 = Option;
                                                    return createElement(el_59, createObj(ofArray([["disabled", course_1.Tasks.some((s) => (s.Id === t_1.Id))], ["value", t_1.Name], ["text", t_1.Name], (elems_8 = [(el_57 = Text$, createElement(el_57, {
                                                        children: t_1.Name,
                                                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])])));
                                                }, model.AllTasks))), ["children", reactApi_1.Children.toArray(Array.from(elems_9))])]))))]), (matchValue_12 == null) ? defaultOf() : matchValue_12),
                                            })));
                                        }));
                                    }
                                }))));
                            }));
                        }));
                    }));
                }))));
            })), ["children", reactApi_1.Children.toArray(Array.from(elems_17))])])));
        }
        default:
            return "Velg en kursmal";
    }
}

export function EditCourseView() {
    let elems_8;
    const setCtx = useCtx()[1];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    useEffectOnce(() => {
        getAllCourses(dispatch, setCtx);
        getTasks(dispatch, setCtx);
    });
    return createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => {
        let matchValue;
        return append((matchValue = screenSize, (matchValue.tag === 0) ? singleton(["flexDirection", "column"]) : ((matchValue.tag === 1) ? singleton(["flexDirection", "column"]) : ((matchValue.tag === 2) ? singleton(["flexDirection", "column"]) : append(singleton(["flexDirection", "row"]), delay(() => singleton(["maxHeight", 85 + "vh"])))))), delay(() => singleton(["gap", 25 + "px "])));
    })))))], (elems_8 = toList(delay(() => {
        let el_19, elems_6, elems, el_2, el, elems_5;
        return append(singleton((el_19 = Card, createElement(el_19, createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 1 + "rem",
        }], (elems_6 = [createElement("div", createObj(singleton_1((elems = [createElement(CreateCourseDialog, {
            trigger: (el_2 = Button, createElement(el_2, {
                icon: (el = AddRegular, createElement(el, {})),
                children: "Ny kursmal",
                size: "medium",
                appearance: "primary",
            })),
            callback: (newCourse) => {
                dispatch(new Msg(0, [append_1([newCourse], model_1.AllCourses)]));
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems))])))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => ((screenSize.tag === 0) ? singleton(["flexGrow", 1]) : ((screenSize.tag === 1) ? singleton(["flexGrow", 1]) : ((screenSize.tag === 2) ? singleton(["flexGrow", 1]) : append(singleton(["overflowY", "scroll"]), delay(() => append(singleton(["width", 300]), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => append(singleton(["gap", 5 + "px "]), delay(() => singleton(["maxHeight", 85 + "vh"])))))))))))))))))], (elems_5 = toList(delay(() => {
            let el_11, matchValue_1, el_8, elems_2;
            return (screenSize.tag === 0) ? singleton((el_11 = Field, createElement(el_11, {
                label: "Velg kursmal",
                children: (matchValue_1 = tryHead([(el_8 = Dropdown, createElement(el_8, createObj(ofArray([["selectedOptions", toArray(defaultArg(map((c) => [c.Name], model_1.SelectedCourse), []))], ["onOptionSelect", (_arg_1, value_1_5) => {
                    dispatch(new Msg(1, [bind((optText) => tryFind((found) => (found.Name === optText), model_1.AllCourses), value_1_5.optionText)]));
                }], (elems_2 = toList(delay(() => map_1((course) => {
                    let elems_1, el_4;
                    const el_6 = Option;
                    return createElement(el_6, createObj(ofArray([["text", course.Name], ["value", course.Name], (elems_1 = [(el_4 = Text$, createElement(el_4, {
                        children: course.Name,
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
                }, sortBy((_arg_2) => _arg_2.Name, model_1.AllCourses, {
                    Compare: comparePrimitives,
                })))), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
            }))) : ((screenSize.tag === 1) ? singleton((el_11 = Field, createElement(el_11, {
                label: "Velg kursmal",
                children: (matchValue_1 = tryHead([(el_8 = Dropdown, createElement(el_8, createObj(ofArray([["selectedOptions", toArray(defaultArg(map((c) => [c.Name], model_1.SelectedCourse), []))], ["onOptionSelect", (_arg_1, value_1_5) => {
                    dispatch(new Msg(1, [bind((optText) => tryFind((found) => (found.Name === optText), model_1.AllCourses), value_1_5.optionText)]));
                }], (elems_2 = toList(delay(() => map_1((course) => {
                    let elems_1, el_4;
                    const el_6 = Option;
                    return createElement(el_6, createObj(ofArray([["text", course.Name], ["value", course.Name], (elems_1 = [(el_4 = Text$, createElement(el_4, {
                        children: course.Name,
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
                }, sortBy((_arg_2) => _arg_2.Name, model_1.AllCourses, {
                    Compare: comparePrimitives,
                })))), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
            }))) : ((screenSize.tag === 2) ? singleton((el_11 = Field, createElement(el_11, {
                label: "Velg kursmal",
                children: (matchValue_1 = tryHead([(el_8 = Dropdown, createElement(el_8, createObj(ofArray([["selectedOptions", toArray(defaultArg(map((c) => [c.Name], model_1.SelectedCourse), []))], ["onOptionSelect", (_arg_1, value_1_5) => {
                    dispatch(new Msg(1, [bind((optText) => tryFind((found) => (found.Name === optText), model_1.AllCourses), value_1_5.optionText)]));
                }], (elems_2 = toList(delay(() => map_1((course) => {
                    let elems_1, el_4;
                    const el_6 = Option;
                    return createElement(el_6, createObj(ofArray([["text", course.Name], ["value", course.Name], (elems_1 = [(el_4 = Text$, createElement(el_4, {
                        children: course.Name,
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
                }, sortBy((_arg_2) => _arg_2.Name, model_1.AllCourses, {
                    Compare: comparePrimitives,
                })))), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
            }))) : map_1((course_1) => {
                let elems_4, el_15, el_13;
                const isSelected = defaultArg(map((c_1) => (c_1.Id === course_1.Id), model_1.SelectedCourse), false);
                const el_17 = Card;
                return createElement(el_17, createObj(ofArray([["onClick", (_arg_4) => {
                    dispatch(new Msg(1, [course_1]));
                }], ["key", `track_level-${course_1.Id}`], ["style", createObj(toList(delay(() => append(singleton(["minHeight", 75]), delay(() => (isSelected ? singleton(["backgroundColor", tokens.colorBrandBackground2Hover]) : empty()))))))], ["appearance", "filled-alternative"], ["selected", isSelected], (elems_4 = [(el_15 = CardHeader, createElement(el_15, {
                    image: (el_13 = Image, createElement(el_13, {
                        style: {
                            height: 48,
                        },
                        src: defaultArg(course_1.ImageUrl, ""),
                    })),
                    header: course_1.Name,
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])));
            }, sortBy((_arg_3) => _arg_3.Name, model_1.AllCourses, {
                Compare: comparePrimitives,
            }))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))))), delay(() => {
            let elems_7, el_21;
            const matchValue_2 = model_1.SelectedCourse;
            if (matchValue_2 != null) {
                const course_2 = matchValue_2;
                return singleton(createElement(SelectedCourseView, {
                    course: course_2,
                    model: model_1,
                    dispatch: dispatch,
                }));
            }
            else {
                return singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexGrow: 1,
                    alignItems: "center",
                    justifyContent: "center",
                }], (elems_7 = [(el_21 = Caption1, createElement(el_21, {
                    children: "Velg kursmal",
                }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

//# sourceMappingURL=EditCourse.jsx.map
